import { baseStoreCreator } from '@/utils/store';

export interface UserAccountsLockPayload {
  hasLockedByAdmin?: boolean;
  hasLockedByMfa?: boolean;
}

export const DEFAULT_VALUES: UserAccountsLockPayload = {
  hasLockedByAdmin: undefined,
  hasLockedByMfa: undefined,
};

export const useStore = baseStoreCreator<UserAccountsLockPayload>(DEFAULT_VALUES);

export default useStore;
